export const DEFAULT_SENTRY_TRACES_SAMPLE_RATE = 0.005;

export function parseSentrySampleRate(
  value: string | undefined,
  fallback = DEFAULT_SENTRY_TRACES_SAMPLE_RATE,
): number {
  const parsed = Number.parseFloat(value ?? '');

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  if (parsed < 0) {
    return 0;
  }

  if (parsed > 1) {
    return 1;
  }

  return parsed;
}
